const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
  'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
  'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine',
  'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
  'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia',
  'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'District of Columbia',
];

const US_STATE_ABBR = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida',
  GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana',
  IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine',
  MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
  MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska',
  NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico',
  NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio',
  OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island',
  SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas',
  UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington',
  WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming', DC: 'District of Columbia',
};

const US_STATE_SET = new Set(US_STATES.map((s) => s.toLowerCase()));

// Inverse of US_STATE_ABBR: full state name (lowercased) → 2-letter abbreviation.
// formatCorridorLabel uses this to recognize the state token, then spells it
// back out in full ("Phoenix, Arizona Corridor") via normalizeUsState.
const US_STATE_TO_ABBR = Object.entries(US_STATE_ABBR).reduce((acc, [abbr, name]) => {
  acc[name.toLowerCase()] = abbr;
  return acc;
}, {});

export function usStateAbbreviation(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  // Already a 2-letter abbreviation (case-insensitive)?
  const upper = s.toUpperCase();
  if (US_STATE_ABBR[upper]) return upper;
  // Otherwise look up by full state name.
  return US_STATE_TO_ABBR[s.toLowerCase()] || null;
}

const CA_PROVINCES = [
  'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
  'Newfoundland and Labrador', 'Nova Scotia', 'Ontario',
  'Prince Edward Island', 'Quebec', 'Saskatchewan',
  'Northwest Territories', 'Nunavut', 'Yukon',
];

const CA_PROVINCE_SET = new Set(CA_PROVINCES.map((p) => p.toLowerCase()));

export function normalizeUsState(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (US_STATE_SET.has(s.toLowerCase())) {
    return US_STATES.find((n) => n.toLowerCase() === s.toLowerCase()) || null;
  }
  const abbr = s.toUpperCase();
  if (US_STATE_ABBR[abbr]) return US_STATE_ABBR[abbr];
  return null;
}

export function isCanadianProvince(raw) {
  if (raw == null) return false;
  return CA_PROVINCE_SET.has(String(raw).trim().toLowerCase());
}

export function isUsState(raw) {
  return normalizeUsState(raw) !== null;
}

export { US_STATES, CA_PROVINCES };
